/* ASSETS *********************************************************************/

// utils
import { randomString } from 'util/string'

// rest webservice api abstraction
import * as api from 'api'


import { SUCCESS_SUFFIX, FAIL_SUFFIX, PROGRESS_SUFFIX } from 'util/dataprovider'
import { makeAction } from 'util/reduxhelper'

// actions
import {
  push as pushNotification,
  update as updateNotification,
  pull as pullNotification
} from 'react-redux/actions/notification'
import { findRelated } from 'react-redux/actions/highlight'

// selectors
import { getItem, getEditItem } from 'react-redux/selectors/asset'
import { getItem as getNotification } from 'react-redux/selectors/notification'

// constants
import * as notificationType from 'component/notification/type'

/* FETCH ASSETS ***************************************************************/

/* Fetch */
export const FETCH_ITEMS = 'asset/list/FETCH_ITEMS'
export const fetchItems = (params) => {
  return (dispatch, getState) => {
    const state = getState()
    const { sort, pagination, pendingQuery } = state.asset.list
    if (!pendingQuery){
      if (!params.hasOwnProperty("max_results"))
        params.max_results = pagination.maxResults
      if (!params.hasOwnProperty("page"))
        params.page = pagination.page
      if (!params.hasOwnProperty("sort_by_field"))
        params.sort_by_field = sort.field
      if (!params.hasOwnProperty("reverse_order"))
        params.reverse_order = sort.reverse[sort.field]
      dispatch(makeAction(FETCH_ITEMS, params))
    }
  }
}
/* automated for convenience @see dataprovider */
export const FETCH_ITEMS_FAIL = FETCH_ITEMS + FAIL_SUFFIX
export const FETCH_ITEMS_SUCCESS = FETCH_ITEMS + SUCCESS_SUFFIX

export const NEXT_PAGE = 'asset/list/NEXT_PAGE'
export const nextPage = () => {
  return makeAction(NEXT_PAGE)
}

/* FETCH ASSET ***************************************************************/

/* Fetch */
export const FETCH_ITEM = 'asset/list/FETCH_ITEM'
export const fetchItem = (uid) => {
  return makeAction(FETCH_ITEM, {uid})
}
/* automated for convenience @see dataprovider */
export const FETCH_ITEM_FAIL = FETCH_ITEM + FAIL_SUFFIX
export const FETCH_ITEM_SUCCESS = FETCH_ITEM + SUCCESS_SUFFIX

//dispatch(findRelated())

/*
dispatch(pushNotification({
  uid: randomString(),
  type: notificationType.ERROR,
  message: FETCH_ITEM_FAIL,
  detail: error,
  timeout: false
}))
*/


/* ASSET FILTER ***************************************************************/

/* Fetch */
export const FETCH_FILTER = 'asset/list/FETCH_FILTER'
export const fetchFilter = () => {
  return makeAction(FETCH_FILTER)
}
/* automated for convenience @see dataprovider */
export const FETCH_FILTER_FAIL = FETCH_FILTER + FAIL_SUFFIX
export const FETCH_FILTER_SUCCESS = FETCH_FILTER + SUCCESS_SUFFIX

/* Save */
export const SAVE_FILTER = 'asset/list/SAVE_FILTER'
export const saveFilter = (filter) => {
  return makeAction(SAVE_FILTER, filter)
}
/* automated for convenience @see dataprovider */
export const SAVE_FILTER_FAIL = SAVE_FILTER + FAIL_SUFFIX
export const SAVE_FILTER_SUCCESS = SAVE_FILTER + SUCCESS_SUFFIX

/* SORT ***********************************************************************/

/* Fetch */
export const FETCH_SORT = 'asset/list/FETCH_SORT'
export const fetchSort = () => {
  return makeAction(FETCH_SORT)
}
/* automated for convenience @see dataprovider */
export const FETCH_SORT_FAIL = FETCH_SORT + FAIL_SUFFIX
export const FETCH_SORT_SUCCESS = FETCH_SORT + SUCCESS_SUFFIX

/* Save */
export const SAVE_SORT = 'asset/list/SAVE_SORT'
export const saveSort = (sort) => {
  return makeAction(SAVE_SORT, sort)
}
/* automated for convenience @see dataprovider */
export const SAVE_SORT_FAIL = SAVE_SORT + FAIL_SUFFIX
export const SAVE_SORT_SUCCESS = SAVE_SORT + SUCCESS_SUFFIX

/* ASSET UPLOAD ***************************************************************/

export const UPLOAD_FILE = 'asset/list/UPLOAD_FILE'
export const uploadFile = (file) => {
  return makeAction(UPLOAD_FILE, file)
}
export const UPLOAD_FILE_PROGRESS = UPLOAD_FILE + PROGRESS_SUFFIX
export const UPLOAD_FILE_FAIL = UPLOAD_FILE + FAIL_SUFFIX
export const UPLOAD_FILE_SUCCESS = UPLOAD_FILE + SUCCESS_SUFFIX

export const CANCEL_UPLOAD = 'asset/list/CANCEL_UPLOAD'
export const cancelUpload = (tid) => {
  return makeAction(CANCEL_UPLOAD, tid)
}

/* ASSET METADATA *************************************************************/

export const SAVE_FILE_META_DATA = 'asset/list/SAVE_FILE_META_DATA'
export const saveFileMetaData = (uid, data) => {
  return makeAction(SAVE_FILE_META_DATA, {uid, data})

}
export const SAVE_FILE_META_DATA_FAIL = SAVE_FILE_META_DATA + FAIL_SUFFIX
export const SAVE_FILE_META_DATA_SUCCESS = SAVE_FILE_META_DATA + SUCCESS_SUFFIX

/* ASSET NAME *****************************************************************/

export const SAVE_NAME = 'asset/edit/SAVE_NAME'
export const saveName = (uid, name) => {
  return (dispatch, getState) => {
    const { fileName, tags } = getItem(getState(), uid)
    dispatch(makeAction(SAVE_NAME, {uid, data: { name, fileName, tags }}))
  }
}

export const SAVE_NAME_FAIL = SAVE_NAME + FAIL_SUFFIX
export const SAVE_NAME_SUCCESS = SAVE_NAME + SUCCESS_SUFFIX

/* ASSET TAGS *****************************************************************/

export const SAVE_TAGS = 'asset/edit/SAVE_TAGS'
export const saveTags = (uid, tags) => {
  return (dispatch, getState) => {
    const { fileName, name } = getItem(getState(), uid)
    dispatch(makeAction(SAVE_NAME, {uid, data: { name, fileName, tags }}))
  }
}

export const SAVE_TAGS_FAIL = SAVE_TAGS + FAIL_SUFFIX
export const SAVE_TAGS_SUCCESS = SAVE_TAGS + SUCCESS_SUFFIX

/* ASSET DELETION *************************************************************/

/**
* Delete an asset
**/
export const DELETE_SINGLE_ITEM = 'asset/edit/DELETE_SINGLE_ITEM'
export const deleteSingleItem = (uid) => {
  return makeAction(DELETE_SINGLE_ITEM, {uid})
}

export const DELETE_SINGLE_ITEM_FAIL = DELETE_SINGLE_ITEM + FAIL_SUFFIX
export const DELETE_SINGLE_ITEM_SUCCESS = DELETE_SINGLE_ITEM + SUCCESS_SUFFIX



// WEBPACK FOOTER //
// ./src/app/react-redux/actions/asset.js